import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { authAction } from "@redux/modules";

const LoginDetails = () => {
  const dispatch = useDispatch();
  const loginDetailsList = useSelector((store) => store.auth.userLoginDetails);
  const [state, setState] = useState({
    transactionsCount: 8,
  });

  useEffect(() => {
    dispatch(authAction.userLoginDetails());
  }, []);

  const handleLoadMore = (event) => {
    event.preventDefault();
    setState({
      ...state,
      transactionsCount:
        (state.transactionsCount ? state.transactionsCount : 8) + 10,
    });
  };

  return (
    <>
      <React.Fragment>
        <h2 className="mb-sm-6 mb-4">Giriş Detaylarım</h2>
        <p className="mb-sm-5 mb-4 fw-light">
          Giriş detaylarınızı bu bölümde görebilir, takip edebilirsiniz.
        </p>

        {/* Başlık Satırı */}
        <div className="d-flex align-items-center justify-content-between py-3 border-bottom font-weight-bold">
          <span className="text-blue-light" style={{ flex: 2 }}>
            Tarih ve Saat
          </span>
          <span className="mx-4" style={{ flex: 1 }}>
            Cihaz
          </span>
          <span className="mx-4" style={{ flex: 1 }}>
            Kullanıcı Adı
          </span>
          <span className="mx-4 " style={{ flex: 1 }}>
            Durum
          </span>
        </div>

        {loginDetailsList
          ? loginDetailsList
              .slice(0, state.transactionsCount ? state.transactionsCount : 8)
              .map((item, i) => (
                <div
                  className="d-flex align-items-center justify-content-between py-3 border-bottom"
                  key={i}
                >
                  <span className="text-blue-light" style={{ flex: 2 }}>
                    {new Date(item.visitDate).toLocaleDateString("tr-TR")}{" "}
                    {new Date(item.visitDate).toLocaleTimeString("tr-TR")}
                  </span>
                  <span className="mx-4" style={{ flex: 1 }}>
                    {item.device}
                  </span>
                  <span className="mx-4" style={{ flex: 1 }}>
                    {item.username}
                  </span>
                  <span
                    className={`badge rounded-pill px-3 py-2 ms-auto
                    ${item.isSuccess ? "bg-green" : "bg-red"}`}
                    style={{ flex: 1 }}
                  >
                    {item.isSuccess ? "Başarılı" : "Başarısız"}
                  </span>
                </div>
              ))
          : null}
        {loginDetailsList?.length -
          (state.transactionsCount ? state.transactionsCount : 8) >
        0 ? (
          <div className="text-center mt-sm-6 mt-5">
            <button
              type="button"
              className="btn btn-blue rounded-pill py-sm-3 py-2 px-sm-4 px-3"
              onClick={(event) => handleLoadMore(event)}
            >
              Daha Fazla Göster
            </button>
          </div>
        ) : null}
      </React.Fragment>
    </>
  );
};

export default LoginDetails;
